var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.134,
    height: 24.234,
    viewBox: "0 0 23.134 24.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachement",
    transform: "translate(-1169.78 -189.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M1170.487,204.045l11.955-11.954a5.732,5.732,0,0,1,4.132-1.708h0a5.84,5.84,0,0,1,4.132,9.972l-11.954,11.955a4.443,4.443,0,1,1-6.283-6.283l10.963-10.963a2.665,2.665,0,0,1,1.9-.78h0a2.578,2.578,0,0,1,1.876.78,2.7,2.7,0,0,1,0,3.794l-7.969,7.97",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M1173.2,206.526l5.069,5.069a3.584,3.584,0,1,1-5.069-5.069Z",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachement);
export default __webpack_public_path__ + "static/media/attachement.6af5e63e75c82cb1b506d98b9a45e322.svg";
export { ForwardRef as ReactComponent };